






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class freightLook extends Vue {
  @Prop(Object) data!:Object;
  @Watch('data', { immediate: true, deep: true })
  onPersonChanged1(val: Object, oldVal: Object) {
    console.log(val);

  }
}
